import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { zIndex } from '../../global/globals';
import media from '../../base/media';
import { clearButtonStyles } from '../../base';

export const Nav = styled.nav`
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	background-color: #fff;
	z-index: ${zIndex.mobileNav};
	opacity: 0;
	transition: opacity 250ms, transform 250ms;
	transform: translate3d(0, -10px, 0);
	pointer-events: none;
	overflow-y: auto;

	${({ open }) => open && css`
		opacity: 1;
		transform: translate3d(0, 0, 0);
		pointer-events: all;
	`}

	${media.tablet`
		padding: 5rem 0;
	`}

	${media.desktopSmall`
		display: none;
	`}
`;

export const NavItem = styled.div`
	padding: 0 2.5rem;

	${media.tablet`
		padding: 0 5rem;
	`}
`;

export const Anchor = styled.a`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	padding: 1.5rem 0;
	color: ${props => props.theme.colors.black};
	font-size: 2.7rem;
	font-weight: 700;
`;

export const SubNav = styled.div`
`;

export const SubNavItem = styled(Link)`
	display: flex;
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
	padding-left: 1.5rem;
	font-size: 2rem;
	color: ${({ theme }) => theme.colors.grayDarker};
`;

export const CloseNavWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	padding: 3rem;
`;

export const SubNavLink = styled.button`
	${clearButtonStyles};
	height: 100%;
	padding: 0 1.5rem;
	margin-right: -1.5rem;
	font-size: 2rem;
	color: ${({ theme }) => theme.colors.black};
	transform: translate3d(0, 4px, 0);

	svg {
		transition: transform 250ms ease, color 250ms ease;
		transform-style: preserve-3d;
	}

	${({ open }) => open && css`
		color: ${({ theme }) => theme.colors.primary};

		svg {
			transform: rotateX(180deg);
		}
	`}
`;
